import React, { FC } from "react";
import styles from "./modal-popper.module.scss";
import { Modal, type ModalProps } from "antd";
import { GrClose } from "react-icons/gr";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  showCloseBtn?: boolean;
};

const ModalPopper: FC<Props & ModalProps> = ({
  isOpen,
  onClose,
  children,
  showCloseBtn = true,
  ...modalProps
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      maskClosable
      centered
      width={"auto"}
      footer={null}
      closable={false}
      classNames={{
        content: styles.popperWindow,
        body: styles.popperBody,
      }}
      {...modalProps}
    >
      {showCloseBtn && (
        <div className={styles.closeBtn} onClick={onClose}>
          <GrClose size={18} />
        </div>
      )}
      {children}
    </Modal>
  );
};

export default ModalPopper;
